<template>
  <div>
    <PageAllow controller="Purchases" action="getIntelligentPurchaseDetails" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-card class="mx-4 mb-4 mt-4">
        <v-card-title class="mx-3">
          {{ $t("PurchasesList.intelligent.select") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-8 text-center subtitle-1">
          <v-row>
            <v-col>
              <v-row class="font-weight-bold text-left pl-3">
                {{
                  $t("PurchasesList.intelligent.purchaseBasis") +
                  $t("Global.colon")
                }}
              </v-row>
              <v-row class="pl-3">
                <v-radio-group v-model="type">
                  <v-radio :key="1" :value="1" hint="123">
                    <template v-slot:label>
                      <span>
                        {{ $t("PurchasesList.intelligent.stock_current") }}
                      </span>
                      <span class="caption">
                        {{ $t("PurchasesList.intelligent.stock_current_hint") }}
                      </span>
                    </template>
                  </v-radio>
<!--                  取消库存上下限类型-->
<!--                  <v-radio :key="2" :value="2">-->
<!--                    <template v-slot:label>-->
<!--                      <span>-->
<!--                        {{ $t("PurchasesList.intelligent.stock_max") }}-->
<!--                      </span>-->
<!--                      <span class="caption">-->
<!--                        {{ $t("PurchasesList.intelligent.stock_max_hint") }}-->
<!--                      </span>-->
<!--                    </template>-->
<!--                  </v-radio>-->
<!--                  <v-radio-->
<!--                    :label="$t('PurchasesList.intelligent.stock_min')"-->
<!--                    :key="3"-->
<!--                    :value="3"-->
<!--                  >-->
<!--                    <template v-slot:label>-->
<!--                      <span>-->
<!--                        {{ $t("PurchasesList.intelligent.stock_min") }}-->
<!--                      </span>-->
<!--                      <span class="caption">-->
<!--                        {{ $t("PurchasesList.intelligent.stock_min_hint") }}-->
<!--                      </span>-->
<!--                    </template>-->
<!--                  </v-radio>-->
                  <v-radio
                    :label="$t('PurchasesList.intelligent.order')"
                    :key="4"
                    :value="4"
                  >
                    <template v-slot:label>
                      <span>
                        {{ $t("PurchasesList.intelligent.order") }}
                      </span>
                      <span class="caption">
                        {{ $t("PurchasesList.intelligent.order_hint") }}
                      </span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="type != 4">
            <v-col>
              <v-row class="font-weight-bold text-left pl-3">
                {{
                  $t("PurchasesList.intelligent.choose_stock") +
                  $t("Global.colon")
                }}
              </v-row>
              <v-row class="pl-3">
                <v-btn
                  color="primary"
                  class="my-1 mr-3"
                  small
                  outlined
                  @click="stocks_dialog = true"
                >
                  {{ $t("PurchasesList.intelligent.choose_stock") }}
                </v-btn>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="9">
                  <v-data-table
                    :headers="stockHeader"
                    :items="stocks"
                    :loading="loading"
                    multi-sort
                    class="elevation-1 pt-2"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          stocks.splice(
                            stocks.findIndex((stock) => stock.id == item.id),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn> </template
                    >d
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-8">
          <v-btn color="primary" @click="nextStep()">
            {{ $t("PurchasesList.intelligent.nextStep") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-sheet>
    <DialogStocks
      v-model="stocks_dialog"
      :stockSelected="stocks"
      @confirm="stocks = $event"
      :types="[0]"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogStocks from "@/components/plugins/DialogStocks";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogStocks,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/purchases",
      },
      {
        text: i18n.t("Nav.intelligentPurchase"),
        disabled: true,
        href: "/intelligent-purchase",
      },
    ],
    stockHeader() {
      return [
        {
          text: i18n.t("Stock.Fields.stock_code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: i18n.t("Stock.Fields.stock_name"),
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {},

  data: () => ({
    stocks_dialog: false,
    stocks: [],
    type: 1,
  }),

  methods: {
    nextStep() {
      if (this.type != 4) {
        var stock_ids = this.stocks
          ? this.stocks.map((stock) => {
              return stock.id;
            })
          : [];
      }
      if (this.type == 4) {
        this.$router.push({
          path: "/intelligent-purchase/purchase-from-order",
          query: { type: 4 },
        });
      } else {
        this.$router.push({
          path: "/intelligent-purchase/intelligent-purchase-create",
          query: { type: this.type, stock_ids: stock_ids },
        });
      }
    },
  },

  watch: {},
};
</script>